<template>
	<div class="login-container" :style="{background:`url(${loginBg}) no-repeat center`,backgroundSize: 'cover'}">
		<div class="login-wrapper">
			<!-- 左侧品牌区域 -->


			<!-- 右侧登录表单 -->
			<div class="form-section">
				<div class="form-wrapper">
					<div class="form-header">
						<div class="u-flex" style="justify-content: space-between;">
							<img src="../../assets/logo1.png" class="logo" />
							<!-- <i class="el-icon-close"></i> -->
						</div>
						<h2 class="form-title">登入<span>大學問總管理中心</span></h2>
					</div>

					<div class="login-form">
						<!-- Email 输入 -->
						<div class="form-group">
							<label class="form-label">帳號</label>
							<div class="input-wrapper">
								<input type="text" class="form-input" placeholder="電子信箱" v-model="form.username" />
							</div>
						</div>

						<!-- 密码输入 -->
						<div class="form-group" style="margin-bottom: 0.12rem;">
							<label class="form-label">密碼</label>
							<div class="input-wrapper">
								<input :type="showPassword ? 'text' : 'password'" class="form-input"
									placeholder="請輸入您的密碼" v-model="form.password" />
								<button type="button" class="password-toggle" @click="showPassword = !showPassword">
									<span class="toggle-icon">{{ showPassword ? '隱藏' : '顯示' }}</span>
								</button>
							</div>
						</div>

						<!-- 服务提示 -->
						<!-- <div class="check-tips">
							<el-checkbox style="margin-right: 0.08rem;" v-model="checked"></el-checkbox>我已同意隱私服務《XXXXX》
						</div> -->

						<!-- 登录按钮 -->
						<button class="login-button" @click="handleLogin">
							<span class="button-text">登入</span>
						</button>

						<!-- 辅助链接 -->
						<div class="helper-links">
							<a href="#" class="helper-link" @click="goToPage('/forgot')">忘記密碼？</a>
							<!-- <span class="link-separator">|</span>
              <a href="#" class="helper-link">註冊新帳號</a> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LoginPage',
		data() {
			return {
				loginBg:'',
				checked: false,
				form: {
					"tenantId": "000000",
					  "username": "",
					  "password": "",
					  "clientId": "46cdd2f4798dc878adcdd481fb5d4aba",
					  "grantType": "password"
				},
				showPassword: false
			}
		},
		mounted() {
			this.$axios
				.post("rest-api/system/app/common/dict-data/list", {
					dictType: 'login_bg'
				})
				.then((res) => {
					if(res.code==200 && res.data.length>0){
						
						this.loginBg = res.data[0].remark
						
						if(window.innerWidth <= 768 && res.data[1]){
							this.loginBg = res.data[1].remark
						}
					}
				})
		},
		methods: {
			toIndex() {
				this.$router.push('/index')
			},
			handleLogin() {
				
				  // 如果已收藏，则取消收藏
				  this.$axios
				    .post('admin-api/auth/app/login', this.form)
				    .then((res) => {
						if(res.code==200){
							
								localStorage.setItem('Authorization',res.data.access_token);
								localStorage.setItem('clientId',res.data.client_id);
								
								this.$message({
								  message: '登入成功',
								  type: 'success'
								});
								this.toIndex()
						}
						
					})
				    .catch((err) => {
						console.log(err,1111111111111111)
					});
			}
		}
	}
</script>

<style scoped lang="scss">
	.login-container {
		min-height: 100vh;
		// background: url('../../assets/bg-login.png') no-repeat center;
		background-size: cover;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0.4rem;
	}

	.login-wrapper {
		position: fixed;
		right: 1.4rem;
		width: 5.6rem;
		background: white;
		border-radius: 0.2rem;
		box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.1);
		overflow: hidden;
		display: flex;
		min-height: 4rem;
	}

	/* 左侧品牌区域 */
	.brand-section {
		flex: 1;
		background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
		color: white;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0.4rem;
	}

	.brand-content {
		text-align: center;
	}

	.brand-title {
		font-size: 0.48rem;
		font-weight: 700;
		margin-bottom: 0.2rem;
		font-family: 'Microsoft JhengHei', '微軟正黑體', sans-serif;
	}

	.brand-subtitle {
		font-size: 0.2rem;
		opacity: 0.9;
		font-weight: 300;
	}

	/* 右侧表单区域 */
	.form-section {
		flex: 1;
		padding: 0.5rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.form-wrapper {
		width: 100%;
	}

	.form-header {
		// text-align: center;
		margin-bottom: 0.4rem;

		.logo {
			width: 1.14rem;
			height: 0.32rem;
		}

		.el-icon-close {
			font-size: 0.26rem;
			cursor: pointer;
			font-weight: bold;
		}
	}

	.form-title {
		font-size: 0.32rem;
		font-weight: bold;
		color: #1f2937;
		margin-top: 0.28rem;

		span {
			font-weight: normal;
			font-size: 0.28rem;
			margin-left: 0.05rem;

		}
	}

	.form-subtitle {
		font-size: 0.2rem;
		color: #6b7280;
	}

	/* 表单样式 */
	.login-form {
		width: 100%;
	}

	.form-group {
		margin-bottom: 0.24rem;
	}

	.form-label {
		display: block;
		font-size: 0.2rem;
		font-weight: 500;
		color: #444;
		margin-bottom: 0.12rem;
	}

	.input-wrapper {
		position: relative;
	}

	.form-input {
		width: 100%;
		padding: 0.12rem 0.2rem;
		border: 1px solid #91A2A480;
		border-radius: 0.08rem;
		font-size: 0.2rem;
		transition: all 0.3s ease;
		background: #91A2A41A;

	}

	// .form-input:focus {
	// 	outline: none;
	// 	border-color: #4f46e5;
	// 	background: white;
	// 	box-shadow: 0 0 0 0.03rem rgba(79, 70, 229, 0.1);
	// }

	.form-input::placeholder {
		color: #9ca3af;
	}

	.password-toggle {
		position: absolute;
		right: 0.12rem;
		top: 50%;
		transform: translateY(-50%);
		background: none;
		border: none;
		color: #6b7280;
		font-size: 0.12rem;
		cursor: pointer;
		padding: 0.04rem 0.08rem;
		border-radius: 0.04rem;
		transition: color 0.3s ease;
	}

	.password-toggle:hover {
		color: #374151;
	}

	/* 服务提示 */
	.service-notice {
		background: #f3f4f6;
		border-radius: 0.08rem;
		padding: 0.2rem;
		margin: 0.24rem 0;
		border-left: 0.03rem solid #4f46e5;
	}

	.notice-item {
		margin-bottom: 0.08rem;
	}

	.notice-item:last-child {
		margin-bottom: 0;
	}

	.notice-text {
		font-size: 0.12rem;
		color: #6b7280;
		line-height: 1.4;
	}

	/* 登录按钮 */
	.login-button {
		width: 100%;
		background: #0BA29B;
		color: white;
		border: none;
		border-radius: 0.08rem;
		padding: 0.2rem;
		font-size: 0.2rem;
		font-weight: bold;
		cursor: pointer;
		transition: all 0.3s ease;
		margin-top: 0.8rem;
	}

	// .login-button:hover {
	// 	transform: translateY(-0.01rem);
	// 	box-shadow: 0 0.04rem 0.12rem rgba(79, 70, 229, 0.4);
	// }

	.login-button:active {
		transform: translateY(0);
	}


	/* 辅助链接 */
	.helper-links {
		text-align: center;
		margin-top: 0.24rem;
		// padding-top: 0.24rem;
		// border-top: 0.01rem solid #e5e7eb;
	}

	.helper-link {
		font-size: 0.2rem;
		color: #0BA29B;
		text-decoration: none;
		transition: color 0.3s ease;
	}

	.helper-link:hover {
		color: #4f46e5;
	}

	.link-separator {
		color: #d1d5db;
		margin: 0 0.08rem;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.login-wrapper {
			flex-direction: column;
			position: inherit;
			max-width: 4.8rem;
			min-height: auto;
		}

		.brand-section {
			padding: 0.3rem;
			min-height: 2rem;
		}

		.brand-title {
			font-size: 0.36rem;
			margin-bottom: 0.12rem;
		}

		.brand-subtitle {
			font-size: 0.2rem;
		}

		.form-section {
			padding: 0.3rem;
		}

		.form-wrapper {
			max-width: none;
		}

		.form-title {
			font-size: 0.28rem;
		}
	}

	@media (max-width: 480px) {
		.login-container {
			padding: 0.1rem;
		}

		.login-wrapper {
			max-width: 100%;
			border-radius: 0.12rem;
		}

		.brand-section {
			padding: 0.24rem;
			min-height: 1.6rem;
		}

		.brand-title {
			font-size: 0.32rem;
		}

		.brand-subtitle {
			font-size: 0.2rem;
		}

		.form-section {
			padding: 0.24rem;
		}

		.form-title {
			font-size: 0.24rem;
		}

		.form-input {
			padding: 0.1rem 0.12rem;
			font-size: 0.2rem;
		}

		.login-button {
			padding: 0.12rem;
			font-size: 0.2rem;
		}
	}

	/* 超小屏幕适配 */
	@media (max-width: 320px) {
		.brand-title {
			font-size: 0.28rem;
		}

		.form-title {
			font-size: 0.2rem;
		}

		.form-input {
			padding: 0.08rem 0.1rem;
		}

		.service-notice {
			padding: 0.12rem;
		}

		.notice-text {
			font-size: 0.11rem;
		}
	}

	.check-tips {
		font-size: 0.2rem;
		color: #999;
	}
</style>